import axios from "axios";
import getAPIUrl from "@/utils/helpers/getApiUrl";

export default {
  async getSolicitudes(context, payload) {
    try {
      const response = await axios.post(
        "api/Solicitudes/get-solicitudes",
        payload
      );
      return response?.data;
    } catch (error) {
      console.error("Error al obtener solicitudes", error);
      // Devolver un array vacío para que los consumidores no reciban `undefined`
      return [];
    }
  },
  async getFiltersByUser() {
    try {
      const response = await axios.get(`api/Solicitudes/get-filters-by-user`);
      return response?.data;
    } catch (error) {
      console.error("Error al cargar los datos del usuario", error);
    }
  },

  async printReceta(context, solicitudHash) {
    try {
      let res = await openFileInNewTab(
        `api/Solicitudes/report/${solicitudHash}`
      );
      return res;
    } catch (error) {
      console.error("Error al cargar los datos del usuario", error);
    }
  },
  async getEstadoSolicitud(_, solicitudId) {
    try {
      return (
        await axios.get(
          `api/Solicitudes/get-solicitud-cambios-estados/${solicitudId}`
        )
      )?.data;
    } catch (error) {
      console.error("Error al traer los Prestadores", error);
    }
  },
  async getMedicamentoADispensar(_, solicitudId) {
    try {
      return (
        await axios.get(
          `/api/solicitudes/medicamentos-a-dispensar/${solicitudId}`
        )
      )?.data;
    } catch (error) {
      console.error("Error al traer los medicamentos a dispensar", error);
    }
  },
  async getReversionDispensa(_, logdispensaId) {
    try {
      return (
        await axios.post(
          `/api/solicitudes/dispensar-medicamentos/revoke/${logdispensaId}`
        )
      )?.data;
    } catch (error) {
      console.error("Error al traer los medicamentos a dispensar", error);
    }
  },
  async postMedicamentoDispensado(context, payload) {
    try {
      const response = await axios.post(
        `api/Solicitudes/dispensar-medicamentos/${payload.solicitudHash}`,
        payload.medicamentos
      );
      return response;
    } catch (error) {
      console.error("Error al dispensar medicamentos", error);
    }
  },
  async anularSolicitud(context, payload) {
    try {
      const response = await axios.delete(
        `/api/solicitudes/anular-solicitud/${payload}`
      );
      return response;
    } catch (error) {
      console.error("Error al anular la solicitud", error);
    }
  },
  async getLogSolicitud(_, solicitudId) {
    try {
      return (await axios.get(`/api/solicitudes/log/${solicitudId}`))?.data;
    } catch (error) {
      console.error("Error al traer los datos", error);
    }
  },
  async getDatosEnvioLog(_, solicitudId) {
    try {
      const response = await axios.get(
        `/api/solicitudes/log-payload/${solicitudId}`
      );
      return response;
    } catch (error) {
      console.error("Error al traer los datos", error);
    }
  },
  async createRecetaElectronica(context, payload) {
    try {
      const response = await axios.post(
        "api/solicitudes/create-receta",
        payload
      );
      return response;
    } catch (error) {
      // Justificación: en errores de red/500 el objeto 'response' puede ser undefined.
      // Evitamos leer 'error.response.status' sin verificar y estandarizamos el log para debug.
      const status = error?.response?.status;
      const data = error?.response?.data;
      console.error("Error al crear receta electrónica", { status, data, error });
      // Re-lanzamos para que el interceptor muestre el mensaje uniforme
      throw error;
    }
  },
  async consultarRenaper(_, payload) {
    // payload: { NroDocumento, IdSexo }
    try {
      const response = await axios.post('api/renaper/consultar-persona', payload);
      return response;
    } catch (error) {
      const status = error?.response?.status;
      if (status === 204) return { status: 204 };
      console.error('Error consultando RENAPER', error);
      throw error;
    }
  },
  async createPrescripcionDispositivos(context, payload) {
    try {
      const response = await axios.post(
        "api/solicitudes/create-prescripcion-dispositivos",
        payload
      );
      return response;
    } catch (error) {
      console.error("Error al crear prescripción de dispositivos", error);
      throw error;
    }
  },
  async sendRecipeByEmail(context, payload) {
    try {
      const response = await axios.post("api/email/send-email", payload);
      return response;
    } catch (error) {
      console.error("Error al enviar email", error);
    }
  },
  async getPrestadorDataByUserIdAndFinanciadorId(_, payload) {
    try {
      return (await axios.get(`/api/solicitudes/prestador-data/${payload}`))
        ?.data;
    } catch (error) {
      console.error("Error al traer los datos del prestador", error);
    }
  },
  async copiarPrescripcionMedicamentos(_, payload) {
    try {
      return (await axios.get(`/api/solicitudes/copiar-prescripcion-medicamentos/${payload}`));
    } catch (error) {
      console.error("Error al traer los datos de la prescripción de medicamentos", error);
    }
  },
  async copiarPrescripcionDispositivos(_, payload) {
    try {
      return (await axios.get(`/api/solicitudes/copiar-prescripcion-dispositivos/${payload}`));
    } catch (error) {
      console.error("Error al traer los datos de la prescripción de dispositivos", error);
    }
  },
  async createPrescripcionEstudios(context, payload) {
    try {
      const response = await axios.post(
        "api/solicitudes/create-prescripcion-estudios",
        payload
      );
      return response;
    } catch (error) {
      console.error("Error al crear prescripción de estudios complementarios", error);
      throw error;
    }
  },
  async copiarPrescripcionEstudios(_, payload) {
    try {
      return (await axios.get(`/api/solicitudes/copiar-prescripcion-estudios/${payload}`));
    } catch (error) {
      console.error("Error al traer los datos de la prescripción de estudios complementarios", error);
    }
  },

  async insertLogSolicitud(context, payload) {
    try {
      const response = await axios.post(
        "api/LogSolicitudes/insert-string",
        payload
      );
      return response?.data;
    } catch (error) {
      console.error("Error al insertar log de solicitud", error);
      throw error;
    }
  },

  // Nuevos métodos para operaciones por CUIR de ítems
  async dispensarMedicamentosPorCuir(context, payload) {
    try {
      // Normalizar ItemsCuir antes de enviar
      const normalizedPayload = {
        ...payload,
        ItemsCuir: (payload.ItemsCuir || []).map(c => (c || '').toString().trim()).filter(c => c)
      };
      
      const response = await axios.post(
        "api/Solicitudes/dispensar-medicamentos-por-cuir",
        normalizedPayload
      );
      return response;
    } catch (error) {
      console.error("Error al dispensar medicamentos por CUIR", error);
      throw error;
    }
  },

  async dispensarDispositivosPorCuir(context, payload) {
    try {
      // Normalizar ItemsCuir antes de enviar
      const normalizedPayload = {
        ...payload,
        ItemsCuir: (payload.ItemsCuir || []).map(c => (c || '').toString().trim()).filter(c => c)
      };
      
      const response = await axios.post(
        "api/Solicitudes/dispensar-dispositivos-por-cuir",
        normalizedPayload
      );
      return response;
    } catch (error) {
      console.error("Error al dispensar dispositivos por CUIR", error);
      throw error;
    }
  },

  async dispensarEstudiosPorCuir(context, payload) {
    try {
      // Normalizar ItemsCuir antes de enviar
      const normalizedPayload = {
        ...payload,
        ItemsCuir: (payload.ItemsCuir || []).map(c => (c || '').toString().trim()).filter(c => c)
      };
      
      const response = await axios.post(
        "api/Solicitudes/dispensar-estudios-por-cuir",
        normalizedPayload
      );
      return response;
    } catch (error) {
      console.error("Error al dispensar estudios por CUIR", error);
      throw error;
    }
  },

  async printRecetaPorItemsCuir(context, itemsCuir) {
    const firstCuir = (itemsCuir.split(',')[0]).trim();

    try {
      let res = await openFileInNewTab(
        `api/Solicitudes/report/cuir/${firstCuir}`
      );
      return res;
    } catch (error) {
      console.error("Error no se pudo imprimir la receta por CUIRs de ítems", error);
    }
  },

  async getPrescripcionesPorFinanciadorYFecha(context, payload) {
    try {
      const params = {
        financiadorId: payload.financiadorId,
        fechaDesde: payload.fechaDesde,
        fechaHasta: payload.fechaHasta,
      };
      
      const response = await axios.get("api/solicitudes/prescripciones-por-financiador", { params });
      return response?.data;
    } catch (error) {
      console.error("Error al obtener prescripciones por financiador y fecha", error);
      // Devolver un array vacío para que los consumidores no reciban `undefined`
      return [];
    }
  },
};

async function openFileInNewTab(endpoint) {
  try {
    const token = sessionStorage.getItem("token");
    const urlAPI = await getAPIUrl();

    await axios({
      method: "get",
      url: `${urlAPI.endsWith("/") ? urlAPI : urlAPI + "/"}${endpoint}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      responseType: "blob", // Especifica que esperamos un blob como respuesta
    })
      .then((response) => {
        // Manejar la respuesta exitosa
        const blob = new Blob([response.data], { type: response.data.type });
        const url = URL.createObjectURL(blob);
        window.open(url, "_blank");
      })
      .catch((error) => {
        // Manejar errores
        console.error("Error al obtener el archivo:", error);
      });
    return true;
  } catch (error) {
    console.error("Error en la función:", error);
    return false;
  }
}
